import React from 'react';
import TableCasino from '../../../../../@casino/ui/table';
import Switch from '@material-ui/core/Switch';
import {useFormik, FormikContext} from "formik";
import { useDispatch, useSelector } from 'react-redux';
import { setGetEventHistoryList } from '../../store/thunk/setGetEventHistoryList';
import {useStyles, rowsHistory, columns} from './helper';
import {getDateFormManually, getDateForm} from '../../../../../@casino/lib/getDate';

const Event = ({groups}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetEventHistoryList({
            search: formik.values.search,
            date_from: 0,
            date_to: new Date().getTime(),
            amount_min:  0,
            amount_max: 1000000,
            label: groups,
            page: 1,
            rowsPerPage: 10
        }))
        // eslint-disable-next-line
    }, [groups]);

    const initialValues = {
        search: '',
        amount_min: '',
        amount_max: '',
        check: false,
        date_from: NaN,
        date_to: NaN
    }

    const formik = useFormik({initialValues});
    const history = useSelector(state => state.groups.event);

    const rows = rowsHistory(history.list)
    
    return (
        <div className={classes.root}>
            <span className={classes.colorFFF}>События</span>
            <div className={classes.divider}></div>
            <FormikContext.Provider value={formik}>
                <form>
                    <div style={{display: 'flex', marginTop: 12, alignItems: 'center'}}>
                        <div style={{display: 'flex', marginRight: 12}}>
                            <label htmlFor="check" className={classes.wrapSwitch}>
                                <span className={classes.manually}>Ручн. время</span>
                                <Switch
                                    checked={formik.values.check}
                                    onChange={() => formik.setFieldValue('check', !formik.values.check)}
                                    color="primary"
                                    name="checkedB"
                                    inputProps={{ 'aria-label': 'primary checkbox' }}
                                />
                            </label>
                            <span className={classes.spo}>С</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                className={classes.datetime}
                                value={formik.values.check ? getDateForm(+formik.values.date_from) : getDateFormManually(+formik.values.date_from)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (!formik.values.check) {
                                        date.setHours(0);
                                        date.setMinutes(0);
                                        date.setSeconds(0);
                                        date.setMilliseconds(0);
                                    }
                                    formik.setFieldValue('date_from', date.getTime());

                                    dispatch(setGetEventHistoryList({
                                        label: groups,
                                        search: formik.values.search,
                                        date_from: isNaN(date.getTime()) ? new Date(0).getTime() : date.getTime(),
                                        date_to: isNaN(formik.values.date_to) ? 0 : formik.values.date_to,
                                        amount_min: +v.target.value ? +v.target.value : 0,
                                        amount_max: formik.values.amount_max ? formik.values.amount_max : 1000000,
                                        page: 1,
                                        rowsPerPage: 10,
                                    }))
                                }}
                            />
                            <span className={classes.spo}>ПО</span>
                            <input 
                                type={formik.values.check ? 'datetime-local' : 'date' }
                                style={{border: 'none', outline: 'none', paddingLeft: 15, borderRadius: 4, background: '#34488c', color: '#fff'}} 
                                value={formik.values.check ? getDateForm(+formik.values.date_to) : getDateFormManually(+formik.values.date_to)}
                                onChange={(v) => {
                                    const date = new Date(v.target.value);
                                    if (formik.values.check) {
                                        date.setHours(23);
                                        date.setMinutes(59);
                                        date.setSeconds(59);
                                        date.setMilliseconds(999);
                                    }
                                    formik.setFieldValue('date_to', date.getTime());
                                    dispatch(setGetEventHistoryList({
                                        label: groups,
                                        search: formik.values.search,
                                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                                        date_to: isNaN(date.getTime()) ? new Date().getTime() : date.getTime(),
                                        amount_min: +v.target.value ? +v.target.value : 0,
                                        amount_max: formik.values.amount_max ? formik.values.amount_max : 1000000,
                                        page: 1,
                                        rowsPerPage: 10,
                                    }))
                                    
                                }}
                            />
                        </div>
                        <div style={{display: 'flex', alignItems: 'center', marginLeft: 20}}>
                            <div style={{marginRight: 20}}>
                                <span style={{color: '#fff'}}>Сумма</span>
                            </div>
                            <div style={{display: 'flex'}}>
                                <span className={classes.spo}>С</span>
                                <input type='text'
                                    className={classes.text}
                                    value={formik.values.amount_min}
                                    onChange={(v) => {
                                        if (!isNaN(+v.target.value)) {
                                            formik.setFieldValue('amount_min', +v.target.value)
                                            dispatch(setGetEventHistoryList({
                                                label: groups,
                                                search: formik.values.search,
                                                date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                                                date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                                amount_min: +v.target.value ? +v.target.value : 0,
                                                amount_max: formik.values.amount_max ? formik.values.amount_max : 1000000,
                                                page: 1,
                                                rowsPerPage: 10,
                                            }))
                                        }
                                    }}
                                />
                                <span className={classes.spo}>ПО</span>
                                <input 
                                    type='text'
                                    className={classes.text}
                                    value={formik.values.amount_max}
                                    onChange={(v) => {
                                        if (!isNaN(+v.target.value)) {
                                            formik.setFieldValue('amount_max', +v.target.value)
                                            dispatch(setGetEventHistoryList({
                                                label: groups,
                                                search: formik.values.search,
                                                date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                                                date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                                amount_min: formik.values.amount_min ? formik.values.amount_min : 0,
                                                amount_max: +v.target.value ? +v.target.value : 1000000,
                                                page: 1,
                                                rowsPerPage: 10,
                                            }))
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <input 
                        type="text"
                        placeholder="Поиск"
                        className={classes.search}
                        value={formik.values.search}
                        onChange={(v) => {
                            formik.setFieldValue('search', v.target.value)
                            dispatch(setGetEventHistoryList({
                                label: groups,
                                search: v.target.value,
                                date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                                date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                                amount_min: formik.values.amount_min ? formik.values.amount_min : 0,
                                amount_max: formik.values.amount_max ? formik.values.amount_max : 1000000,
                                page: 1,
                                rowsPerPage: 10,
                            }))
                        }}
                    />
                </form>
            </FormikContext.Provider>
            <div style={{marginTop: 20}}>
                <TableCasino 
                    pagination
                    allPage={history.count}
                    width={1300}
                    perPage={10}
                    columns={columns}
                    rows={rows}
                    changePage={(v) => dispatch(setGetEventHistoryList({
                        label: groups,
                        search: formik.values.search,
                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                        amount_min: formik.values.amount_min ? formik.values.amount_min : 0,
                        amount_max: formik.values.amount_max ? formik.values.amount_max : 1000000,
                        page: +v.page+1,
                        rowsPerPage: v.rowsPerPage,
                    }))}
                    changeRowsPerPage={(v) => dispatch(setGetEventHistoryList({
                        label: groups,
                        search: formik.values.search,
                        date_from: isNaN(formik.values.date_from) ? 0 : formik.values.date_from,
                        date_to: isNaN(formik.values.date_to) ? new Date().getTime() : formik.values.date_to,
                        amount_min: formik.values.amount_min ? formik.values.amount_min : 0,
                        amount_max: formik.values.amount_max ? formik.values.amount_max : 1000000,
                        page: +v.page + 1,
                        rowsPerPage: v.rowsPerPage,
                    }))}
                />
            </div>
            
        </div>
    )
}

export default Event;